export const profile = {
    name: "PIKDOV STUDIO",
    email: "pikdovstudio@gmail.com",
    phone: "+50687041526",
    whatsappUrl: "https://wa.me/50687041526",
    telegramUrl: "https://t.me/ypikdov",
    website: "https://www.ypikdov.cv",
    blogUrl: "https://ypikdov.blogspot.com/",
    social: {
        facebook: "https://www.facebook.com/ypikdov",
        instagram: "https://www.instagram.com/ypikdov_",
        linkedin: "https://www.linkedin.com/in/ypikdov",
        github: "https://github.com/ypikdov",
    },
    // Icon keys for FontAwesome (imported where needed)
    socialIcons: [
        { key: "facebook", icon: "faFacebook", labelKey: "footer.social.facebook" },
        { key: "instagram", icon: "faInstagram", labelKey: "footer.social.instagram" },
        { key: "linkedin", icon: "faLinkedin", labelKey: "footer.social.linkedin" },
        { key: "github", icon: "faGithub", labelKey: "footer.social.github" },
    ],
    urls: {
        cvSpanish: "https://mega.nz/file/gZIwQIyD#R5XcIE0WpR_zy-Wl2TWD86Qg17WnPi7d3DQgOi4OKbk",
        cvEnglish: "https://mega.nz/file/kQRRCJiK#9Fv9FneRXUThNYYzxNa27SsIoDRtRcpLqpFIjvXjGLI",
    },
    location: {
        mapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15682.02983751717!2d-84.978161461145!3d10.47055088266782!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f9fe99f9231712d%3A0x14e1610260498b58!2sTilar%C3%A1n%2C%20Guanacaste%20Province!5e0!3m2!1sen!2scr!4v1727530138986!5m2!1sen!2scr"
    }
};
